import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import multi from 'redux-multi'
import crashReporter from 'core/crash-reporter/middleware'

import rootReducer from 'reducers'

const middlewares = [thunk, multi, crashReporter]

// https://github.com/zalmoxisus/redux-devtools-extension#redux-devtools-extension
const devToolsFn = '__REDUX_DEVTOOLS_EXTENSION__'
const enhancer = compose(
  applyMiddleware(...middlewares),
  (window[devToolsFn] && window[devToolsFn]()) || ((f) => f),
)

// See https://github.com/rackt/redux/releases/tag/v3.1.0
const store = createStore(rootReducer, {}, enhancer)

// Hot reload reducers (requires Webpack or Browserify HMR to be enabled)
if (__DEV__ && module.hot) {
  module.hot.accept('reducers', () =>
    // Don't forget to remove `()` if you change reducers back to normal rootReducer.
    // eslint-disable-next-line global-require
    store.replaceReducer(require('reducers').default()),
  )
}

export default store
